import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { useFormikContext } from "formik";
import { Cancel } from "@mui/icons-material";
import Utils from "../../utils";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";

//TODO: consider abstracting this by using the newly created "MultiSelect" from /common, when there is capacity
function SDGSelect() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  const handleSelectedChipRemoval = (id: number) => {
    return context.setFieldValue(
      "solution-sdg",
      context.values["solution-sdg"]?.filter((selected) => selected !== id),
    );
  };

  return (
    <FormControl fullWidth>
      <InputLabel variant="standard" id="solution-sdg-label">
        SDGs
      </InputLabel>
      <Select
        variant="standard"
        labelId="solution-sdg-label"
        id="solution-sdg"
        name="solution-sdg"
        multiple
        value={context.values["solution-sdg"]}
        onChange={context.handleChange}
        renderValue={(selected) => (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", padding: 0.5, gap: 0.5 }}
          >
            {selected.map((value) => (
              <Chip
                key={value}
                sx={{
                  backgroundColor: Utils.SDG.getSDGChipColor(value),
                  color: "white",
                  fontWeight: 600,
                }}
                label={`${value}. ${Utils.SDG.getSDGDisplayValue(value)}`}
                onDelete={() => handleSelectedChipRemoval(value)}
                deleteIcon={
                  <Cancel onMouseDown={(event) => event.stopPropagation()} />
                }
              />
            ))}
          </Box>
        )}
      >
        {Utils.SDG.SDGOptions.map(
          (option: { id: number; displayValue: string }) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox
                checked={context.values["solution-sdg"]?.includes(option.id)}
              />
              <ListItemText
                primary={`${option.id}. ${Utils.SDG.getSDGDisplayValue(
                  option.id,
                )}`}
              />
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
}

export default SDGSelect;
